import { fetchDataAndProceed } from '../../config/utils';
import { METHOD_TYPES } from '../../config/constants';

export const fetchKpiFilterAndData = (data, callback) => {
  return fetchDataAndProceed('/admin/v1/agentKpi', METHOD_TYPES.POST, data, callback, 0)
}

export const getAgentLiveKpis = (data, callback) => {
  return fetchDataAndProceed('/admin/v1/getLiveKpi', METHOD_TYPES.POST, data, callback)
}



// WEBPACK FOOTER //
// ./src/data/redux/kpi_details/api.js